import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import DetailsView from "../core/detailsView";
import { api } from "../../api";

import { getDetailViewConfig } from "./configs/incidentsDetailViewConfig";

const IncidentPage = () => {
  const { state } = useLocation();
  const { id } = useParams();
  const [detailViewConfig, setDetailViewConfig] = useState({});
  const [data, setData] = useState(state);

  // Load the incident. We usually arrive with router state (the row from the list), but list rows
  // are ANONYMIZED — the student id/identity is stripped per row. So we ALWAYS re-fetch the
  // authoritative record by id: the by-id GET reveals studentData when the incident is a
  // student-flagged emergency or an approved de-anonymization (FEAT-022), and returns the latest
  // fields. Router state is used only for an instant first paint. (Trusting state alone was why an
  // approved de-anon never showed the student's identity when the incident was opened from the list.)
  useEffect(() => {
    const fetchData = async () => {
      if (state) setData({ ...state });
      let record = state;
      if (id) {
        const res = await api("get", { id }, "Incidents");
        if (res.status === 200) {
          const fetched = res.data && res.data.data ? res.data.data : res.data;
          if (fetched && fetched.id) {
            record = fetched;
            setData({ ...fetched });
          }
        }
      }
      const config = await getDetailViewConfig(record);
      setDetailViewConfig(config);
    };
    fetchData();
    // eslint-disable-next-line
  }, [state, id]);

  return (
    <>
      {detailViewConfig?.type && data ? (
        <DetailsView
          data={data}
          titleConfig={detailViewConfig.titleConfig}
          type={detailViewConfig.type}
          title={detailViewConfig.title}
          tabs={detailViewConfig.tabs}
          mainAction={detailViewConfig.mainAction}
          actionItems={detailViewConfig.actionItems}
          headerConfig={detailViewConfig.headerConfig}
        />
      ) : (
        <div></div>
      )}
    </>
  );
};

export default IncidentPage;
